module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"cancelLink":"Desativar link","alert-cancel-success":"Link cancelado com sucesso!"},"en-US":{"cancelLink":"Disable Link","alert-cancel-success":"Link canceled successfully!"}}')
  delete Component.options._Ctor
}
